import moment from 'moment';
import { getRoomOccupyReport } from '../services/report';
import { getZoneTreeData } from '../services/calender';
import { PATHS, RES_STATUS, ROOM_CAPACITY } from '../utils/constants';
import { message } from 'antd';

// 校验开始日期和结束日期
const checkTime = ({startTime, endTime, messages}) => {
  if(startTime.valueOf() > endTime.valueOf()) {
    // 开始日期大于结束日期
    message.warn(messages['start_greater_than_end']);
    return false;
  }
  const start = startTime.valueOf();
  const end = endTime.valueOf();
  if(moment(end).subtract(1, 'months').subtract(1, 'days').valueOf() > start.valueOf()) {
    message.warn(messages['start_greater_then_end_one_month']);
    return false;
  }
  return true;
};
export default {
  namespace: 'roomOccupyReport',
  state: {
    startTime: moment().subtract(1, 'months'),
    endTime: moment().endOf('day'),
    // 前端界面使用的开始时间和结束时间
    sTime: moment().subtract(1, 'months'),
    eTime: moment().endOf('day'),
    meetingTreeData: { child: [] },
    meetingSearchInfo: {
      moreMeeting: []
    },
    roomOccupyChartData: [],
    roomUseHotChartData: [],
    roomList: [],
    occTimeBlocks: []
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    },
    setMeetingTreeData(state, { meetingTreeData }) {
      return { ...state, meetingTreeData };
    },
    setRoomOccupyChartData(state, {roomOccupyChartData}) {
      return { ...state, roomOccupyChartData };
    },
    setRoomUseHotChartData(state, {roomUseHotChartData}) {
      return { ...state, roomUseHotChartData };
    }
  },
  effects: {
      // 会议室占用情况
    * searchRoomOccupy({startTime, endTime}, { call, select, put }) {
      const { locale ,messages } = yield select(state => state.i18n);
      const{meetingSearchInfo: {moreMeeting}} = yield select(state => state.roomOccupyReport);
      let idStr = '';
      if (moreMeeting && moreMeeting.length > 0) {
        idStr = moreMeeting.join(';')
      }
      if(!checkTime({startTime, endTime, messages})) {
        return;
      }
      const {data, status, msg} = yield call(getRoomOccupyReport, {
        startDate: startTime.valueOf(),
        endDate: endTime.valueOf(),
        roomIds: idStr,
        locale: locale
      });
      if(status === RES_STATUS.success){
        const {roomOccs: occupyDataList, occTimeBlocks, startDate, endDate} = data;
        // 会议室占用报表数据
        const occupyData = [];
        // 会议室使用时段热门指数
        const useHotData = [];
        // 会议室数量
        const rList = [];
        if(occupyDataList && occupyDataList.length > 0) {
          occupyDataList.forEach((item) => {
            // 会议室信息 {}
            const room = item.room;
            rList.push(room);
            // 会议室占用百分比 []
            const rates = item.rates;
            // 构造数据占用报表数据
            if(rates && rates.length > 0) {
              rates.forEach((value, index) => {
                let ratesData = {};
                ratesData.day = index;
                ratesData.rate = value;
                ratesData.roomName = room.name;
                ratesData.roomNameEn = room.nameEn;
                // 日期
                ratesData.date = moment(startTime).add(ratesData.day, "days").valueOf();
                occupyData.push(ratesData);
              });
            };
          });
        };

        // 构造使用时段热门指数
        if(occTimeBlocks && occTimeBlocks.length > 0) {
          occTimeBlocks.forEach((bItem) => {
            for(let i=0; i<parseInt(bItem.occNum); i++){
              useHotData.push({
                quarterNumOfDay: bItem.quarterNumOfDay
              });
            }
          });
        }
        yield put({ type: 'setState', payload: {
            startTime: moment(startDate),
            endTime: moment(endDate),
            sTime: moment(startDate),
            eTime: moment(endDate),
            roomOccupyChartData: occupyData,
            roomUseHotChartData: useHotData,
            roomList: rList,
            occTimeBlocks
          }});
      } else {
        message.warn(msg);
      }
    },
    // 获取会议室列表
    * getMeetingTreeDataForSearch({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment().startOf('day').valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        exceptCpties: ROOM_CAPACITY.webex,//会议室占用统计排除webex会议室
        lang: locale
      });
      yield put({ type: 'setMeetingTreeData', meetingTreeData: data.data });
    },
    // 重置
    * resetData({}, { select, put, call }) {
      yield put({ type: 'setState', payload: {
          startTime: moment().subtract(1, 'months'),
          endTime: moment().endOf('day'),
          sTime: moment().subtract(1, 'months'),
          eTime: moment().endOf('day'),
          meetingSearchInfo: {
            moreMeeting: []
          },
          roomOccupyChartData: [],
          roomUseHotChartData: []
        }});
    }
  },
  subscriptions : {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.roomOccupyReport) {
          dispatch({ type: 'setState', payload: {
              startTime: moment().subtract(1, 'months'),
              endTime: moment().endOf('day'),
              sTime: moment().subtract(1, 'months'),
              eTime: moment().endOf('day'),
              meetingTreeData: { child: [] },
              meetingSearchInfo: {
                moreMeeting: []
              },
              roomOccupyChartData: [],
              roomUseHotChartData: []
            }});
          dispatch({ type: 'getMeetingTreeDataForSearch' })
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomOccupyReport.js